import React from "react";
import { NavLink as Link } from "react-router-dom";
const Resources = (props) => {
  return (
    <div className="Resources">
      <h1>Resources</h1>
      <br />
      <div className="hoverBox">
        <Link to="/BalanceSheet"> Balance Sheet (Subcribers only)</Link>
        <br />
        Use this tool to see a breakdown of your finances.
      </div>
      <br />

      <div className="hoverBox">
        <Link to="/ComingSoon"> Home Budget Worksheet (PDF)</Link>
        <br />
        Coming Soon!
      </div>
      <br />
      <div className="hoverBox">
        <Link to="/ComingSoon"> Interactive Cash Flow Statement </Link>
        <br />
        Coming soon!
      </div>
      <br />
      <h1>Calculators</h1>
      <br />
      <div className="hoverBox">
        <Link to="/NPVtest"> Net Present Value Calculator </Link>
        <br />
        Use this tool to find out if a potential investment will bring you
        profit in the long term.
      </div>
      <br />
      <div className="hoverBox">
        <Link to="/inflation"> Inflation Calculator (Subcribers only)</Link>
        <br />
        Use this tool to adjust any given amount of money for inflation over a
        specific timeline.
      </div>
      <br />
      <div className="hoverBox">
        <Link to="/MC"> QFP® Monte Carlo Calculator (Subcribers only)</Link>
        <br />
        Use this tool to predict a set of outcomes based on an estimated range
        of values versus a set of fixed input values.
      </div>
      <br />

      <div className="hoverBox">
        <Link to="/ComingSoon"> Life Insurance Calculator </Link>
        <br />
        Coming soon!
      </div>
      <br />
    </div>
  );
};

export default Resources;
